// @ts-nocheck
import React, { FC } from 'react';
import { createIconSetFromIcoMoon } from 'react-native-vector-icons';
import { IconProps as RNVIIconProps } from 'react-native-vector-icons/Icon';
import { StyleSheet, View, StyleProp, ViewStyle } from 'react-native';
import colors from '@packages/core/styles/colors';
import icoMoonConfig from '../assets/sts-icons.json';

const STSIcon = createIconSetFromIcoMoon(icoMoonConfig, 'STS-Icons', 'STS-Icons.ttf');
export interface IconProps extends RNVIIconProps {
    name: StsIconName | string;
    hero?: boolean;
    heroContainerStyle?: StyleProp<ViewStyle>;
    raised?: boolean;
    raisedContainerStyle?: StyleProp<ViewStyle>;
    color?: keyof typeof colors;
    status?: boolean;
}

export const Icon: FC<IconProps> = ({
    hero,
    heroContainerStyle,
    raised,
    raisedContainerStyle,
    color,
    status,
    ...iconProps
}) => {
    let iconSize = 24;
    if (status) {
        iconSize = 16;
    } else if (hero) {
        iconSize = 120;
    }
    const colorHex = colors[color || (hero ? 'graySix' : color || 'textDarkSecondary')];
    const icon = <STSIcon color={colorHex} size={iconSize} {...iconProps} />;

    if (hero) {
        return (
            <View
                style={[
                    styles.heroIconContainer,
                    heroContainerStyle,
                    color === 'white' && { backgroundColor: colors.blueOne },
                ]}
            >
                {icon}
            </View>
        );
    }

    if (raised) {
        return <View style={[styles.raisedIconContainer, raisedContainerStyle]}>{icon}</View>;
    }

    return icon;
};

const styles = StyleSheet.create({
    raisedIconContainer: {
        backgroundColor: colors.white,
        borderRadius: 50,
        height: 32,
        width: 32,
        justifyContent: 'center',
        alignItems: 'center',
        shadowColor: colors.black,
        shadowOffset: {
            width: 0,
            height: 2,
        },
        shadowOpacity: 0.23,
        shadowRadius: 2.62,

        elevation: 4,
    },
    heroIconContainer: {
        padding: 36,
        borderRadius: 100,
        backgroundColor: colors.grayTwo,
    },
});

export const StsIconNamesAsArray = [
    'administration',
    'account-tree',
    'add-circle',
    'arrow-back',
    'arrow-double-up',
    'arrow-forward',
    'arrow-small-down',
    'arrow-small-up',
    'auto-cvt',
    'barcode-scan',
    'qrcode-scan',
    'trash-can',
    'tray-arrow-up',
    'battery',
    'bell-outline',
    'bell',
    'calendar',
    'calender-month',
    'camera',
    'car-lift',
    'car-repair',
    'car-subaru',
    'chat-bubble-text',
    'chat-bubble',
    'check-circle-hollow',
    'checkbox-group',
    'checkbox-indeterminate',
    'checkbox-marked',
    'checkbox-unmarked',
    'checkmark',
    'chevron-down',
    'chevron-left',
    'chevron-right',
    'chevron-up',
    'circle-indeterminate',
    'clock',
    'close',
    'connector',
    'copy',
    'download',
    'draggable',
    'ecm',
    'electrical',
    'entity',
    'error',
    'escalation',
    'export',
    'eye-off',
    'eye',
    'file',
    'filter',
    'filter-list',
    'flag',
    'folders',
    'fork',
    'gear-outline',
    'gear',
    'headset',
    'history',
    'home',
    'hub-dms',
    'image-collection',
    'image',
    'info',
    'info-solid',
    'keyboard-return',
    'keyword-preview',
    'launch',
    'library-add',
    'likert-long-text',
    'likert',
    'list',
    'lock-closed',
    'lock-open',
    'logout',
    'long-text',
    'magnify-minus-outline',
    'magnify-plus-outline',
    'magnifying-glass',
    'mark-as-read',
    'mark-as-unread',
    'menu',
    'microphone-outline',
    'minus',
    'more-dots-vertical',
    'more-dots',
    'open-in-browser',
    'open-in-full',
    'open-in-new',
    'paintbrush-outline',
    'paintbrush',
    'paperclip',
    'paragraph',
    'pencil',
    'phone',
    'plug',
    'plus',
    'question-mark',
    'radio-group',
    'radio-marked',
    'radio-unmarked',
    'recall-swap-driving',
    'refresh',
    'repair-order',
    'retry-refresh',
    'schedule',
    'search',
    'search-off',
    'select',
    'share',
    'short-text',
    'star-filled',
    'star-unfilled',
    'sync-down',
    'system_update',
    'title',
    'trash-striped',
    'trash',
    'unplugged',
    'update',
    'upload-in-progress',
    'upload',
    'user',
    'videocam',
    'warning',
    'wifi-off',
    'workflow',
    'x-circle',
    'x-close',
    'upload-new',
] as const;

export type StsIconName = (typeof StsIconNamesAsArray)[number];

export const isValidIconType = (type: StsIconName) => {
    return StsIconNamesAsArray.includes(type);
};
